module.exports = __webpack_public_path__ + "static/10-9740569aa83b57a93ff2a7e7141ce81b.jpg";